<template>
  <button type="button" :style="{ color: textColor }">{{ message }}</button>
</template>

<script>
export default {
  props: {
    message: String,
    backgroundColor: String,
    textColor: String
  }
}
</script>

<style lang="scss" scoped>
button {
  margin: 5px;
  padding: 2px;
  width: 100%;
  border-radius: 8px;
  font-weight: 500;
}
</style>
